module.exports = __webpack_public_path__ + "img/8-weathervalve2.e542eb94.png";